import React, { Component } from "react";
import Autocomplete from "react-autocomplete";
import API from "../../apiService.js";
import moment from "moment";
import ALERT from "../component/Alert";
import { Formik, Form } from "formik";
import * as Yup from "yup";
const SignupSchema = Yup.object().shape({
  icd: Yup.string().required("ICD HARUS DIISI"),
});
export class Assesment extends Component {
  constructor(props) {
    super(props);
    // console.log(props.patient.id)
    this.state = {
      date: moment(new Date()).format("YYYY-MM-DD"),
      dataIcd: [],
      dataTreatments: [],
      workRelatedDisease: [],
      wrd: {},
      icd: [
        {
          visit_id: "",
          visit_inpatient_detail_id: "",
          icd_code: "",
          icd_name: "",
          explanation: "",
          date: "",
          case: "new",
          elemen_teeth: "",
          log: false,
          examination_type_id: "",
        },
      ],
      icd_keluarga: [
        {
          visit_id: "",
          visit_inpatient_detail_id: "",
          icd_code: "",
          icd_name: "",
          explanation: "",
          date: "",
          case: "new",
          elemen_teeth: "",
          log: false,
          examination_type_id: "",
        },
      ],
      icd_komunitas: [
        {
          visit_id: "",
          visit_inpatient_detail_id: "",
          icd_code: "",
          icd_name: "",
          explanation: "",
          date: "",
          case: "new",
          elemen_teeth: "",
          log: false,
          examination_type_id: "",
        },
      ],
      treatments: [
        {
          visit_id: "",
          visit_inpatient_detail_id: "",
          treatment_id: "",
          log: "0",
          treatment: { name: "" },
        },
      ],

      value: "",
      icdSelected: "",
      data:
        props.patient.examinations.length > 0
          ? props.patient.examinations[0]
          : [],
      icpc_individu: {
        visit_id: "",
        explanation: "",
        log: 0,
        category: "icpc_individu",
        icd_name: "",
        soap: "A",
        code: "",
        icd10: "",
      },
      icpc_keluarga: {
        visit_id: "",
        explanation: "",
        log: 0,
        category: "icpc_keluarga",
        icd_name: "",
        soap: "A",
        code: "",
        icd10: "",
      },
      icpc_komunitas: {
        visit_id: "",
        explanation: "",
        log: 0,
        category: "icpc_komnunitas",
        icd_name: "",
        soap: "A",
        code: "",
        icd10: "",
      },

      list_icpc: [],
    };
    this.timeout = 0;
    // Bind `this` context to functions of the class
    this.onChangeIcd = this.onChangeIcd.bind(this);
    this.onSelect = this.onSelect.bind(this);
    this.getItemValue = this.getItemValue.bind(this);
    this.renderItem = this.renderItem.bind(this);
    this.retrieveDataAsynchronouslyIcd =
      this.retrieveDataAsynchronouslyIcd.bind(this);

    this.onChangeIcpc = this.onChangeIcpc.bind(this);
    this.onSelectIcpc = this.onSelectIcpc.bind(this);
    this.getItemValueI = this.getItemValueIcpc.bind(this);
    this.renderItemIcpc = this.renderItemIcpc.bind(this);
    this.retrieveDataAsynchronouslyIcpc =
      this.retrieveDataAsynchronouslyIcpc.bind(this);
    this.postIcpc = this.postIcpc.bind(this);

    this.getWorkRelatedDisease();
  }

  componentDidMount() {
    if (this.props.patient.diagnoses[0]) {
      this.setState({
        icd: this.props.patient.diagnoses,
      });
    }
    this.getIcpc();
    this.icd.focus();
    this.getIcpc();
  }

  getIcpc = async () => {
    const res = await API.get(
      "registration/icpc-transaction/read/" + this.props.patient.id
    );
    if (res) {
      if (res.code == 200) {
        let data = [];
        res.data.map((a, e) => {
          this.state[a.category][0].code != ""
            ? (data = this.state[a.category])
            : (data = []);
          if (a.soap == "A") {
            let dt = {
              ...a,
              icd_name: a.icpc ? a.icpc[0].name : "",
            };
            this.setState({
              [a.category]: [...data, dt],
            });
            if (a.diagnoses && a.diagnoses.length > 0) {
              switch (a.category) {
                case "icpc_individu":
                  this.setState({
                    icd: a.diagnoses,
                  });
                  break;
                case "icpc_keluarga":
                  this.setState({
                    icd_keluarga: a.diagnoses,
                  });
                  break;
                case "icpc_komunitas":
                  this.setState({
                    icd_komunitas: a.diagnoses,
                  });
                  break;
                default:
                // code block
              }
            }
          }
        });
      }
    }
  };

  getWorkRelatedDisease = async () => {
    const res = await API.get("management/work_related_disease/read");
    if (res.code === 200) {
      this.setState({
        workRelatedDisease: res.data,
      });
    } else {
      console.error("Cannot load data from remote source");
    }
  };

  handleNameChange = (evt) => {
    this.setState({ name: evt.target.value });
  };

  handleInputNameChangeIcd = (idx, icdnew) => (evt) => {
    const val = evt.split("_", 3);
    const newIcd = this.state[icdnew][idx].diagnoses.map((icd, sidx) => {
      if (0 !== sidx) return icd;
      return {
        ...icd,
        visit_id: this.props.patient.id,
        visit_inpatient_detail_id: "0",
        icd_code: val[0],
        icd_name: val[1],
        explanation: "",
        date: this.state.date,
        case: "new",
        elemen_teeth: "0",
        log: false,
        examination_type_id: "0",
        icd10: { non_specialist: val[2] },
        icpc2: "",
      };
    });
    let data = this.state[icdnew];
    data[idx].icd10 = val[0];
    data[idx].diagnoses = newIcd;
    this.setState({ [icdnew]: data }, () => {
      let parent = [];
      console.log(this.state.icpc_individu[0]?.diagnoses);
      parent = { data: this.state.icpc_individu[0]?.diagnoses, param: "diagnoses" };
      this.props.parentCallback(parent);
    });
  };

  handleSubmit = (evt) => {
    this.postIcd();
    this.postIcpc();
  };

  postIcd = async (e) => {
    var param = this.state.data;
    const anam = await API.put("registration/examination/update", param);
    const res = await API.post("/management/diagnoses/create", { diagnose: this.state.icd });
    if (res.code === 200) {
      ALERT("success", "Berhasil Menyimpan Data ");
    } else {
      ALERT("error", "gagal menyimpan data");
    }
  };

  postIcpc = async (e) => {
    const individu = {
      ...this.state.icpc_individu,
      diagnoses: this.state.icd,
      icd10: this.state.icd[0].icd_code,
    };
    let diagkel = {
      ...this.state.icpc_keluarga,
      diagnoses: this.state.icd_keluarga,
      icd10: this.state.icd_keluarga[0].icd_code,
    };
    let diagkom = {
      ...this.state.icpc_komunitas,
      diagnoses: this.state.icd_komunitas,
      icd10: this.state.icd_komunitas[0].icd_code,
    };
    console.log(this.state)
    console.log(diagkom)
    if (individu.visit_id !== "") {
      const icpcIndividu = await API.post(
        "registration/icpc-transaction/create",
        individu
      );
    }
    if (diagkel.visit_id !== "") {
      const icpcKeluarga = await API.post(
        "registration/icpc-transaction/create",
        diagkel
      );
    }
    if (diagkom.visit_id !== "") {
      const icpcKomunitas = await API.post(
        "registration/icpc-transaction/create",
        diagkom
      );
    }

    // const res = await API.post("registration/icpc-transaction/create", { diagnose });
    // if(res){
    //   console.log(res, "berhasil");
    // } else {
    //   console.log(res, "gagal")
    // }
  };

  handleAddInput = (x) => (evt) => {
    this.setState({
      [evt.target.name]: x,
    });
  };

  handleRemoveInputIcd = (idx) => (evt) => {
    // const val = evt.target.value;
    const icd = [...this.state[evt.target.name]];
    icd[idx].log = true;
    if (icd[idx].icd_name !== "") {
      this.setState({ [evt.target.name]: icd });
    } else {
      this.setState({
        [evt.target.name]: this.state[evt.target.name].filter(
          (s, sidx) => idx !== sidx
        ),
      });
    }
  };

  retrieveDataAsynchronouslyIcd = async (e) => {
    // console.log(e);

    const res = await API.get("management/icd10/read?keyword=" + e);
    if (res.code === 200) {
      this.setState({
        dataIcd: res.data.data,
      });
    } else {
      console.error("Cannot load data from remote source");
    }
  };

  onChangeIcd = (idx, icdnew) => (evt) => {
    const newIcd = this.state[icdnew].diagnoses.map((icd, sidx) => {
      if (idx !== sidx) return icd;
      return {
        ...icd,
        visit_id: this.props.patient.id,
        visit_inpatient_detail_id: "",
        icd_code: "",
        icd_name: evt.target.value,
        explanation: "",
        date: this.state.date,
        case: "new",
        elemen_teeth: "",
        log: false,
        examination_type_id: "",
      };
    });
    // console.log(newIcd);
    // this.setState({ [icdnew]: newIcd });

    /**
     * Handle the remote request with the current text !
     */
    const par = evt.target.value;
    if (this.timeout) clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      if (par.length > 2) {
        this.retrieveDataAsynchronouslyIcd(par);
      }
    }, 500);
  };

  /**
   * Callback triggered when the autocomplete input changes.
   *
   * @param {Object} val Value returned by the getItemValue function.
   * @return {Nothing} No value is returned
   */
  onSelect(val) {
    this.setState({
      value: val,
    });
    const x = val.split("_", 2);
    console.log("Option from 'database' selected : ", x);
  }

  /**
   * Define the markup of every rendered item of the autocomplete.
   *
   * @param {Object} item Single object from the data that can be shown inside the autocomplete
   * @param {Boolean} isHighlighted declares wheter the item has been highlighted or not.
   * @return {Markup} Component
   */
  renderItem(item, isHighlighted) {
    return (
      <div
        key={item ? item.id : 0}
        style={{ background: isHighlighted ? "lightgray" : "white" }}
      >
        {item?.code} _ {item?.name} _ [{item?.name_en}]
      </div>
    );
  }

  getItemValue(item) {
    // You can obviously only return the Label or the component you need to show
    // In this case we are going to show the value and the label that shows in the input
    // something like "1 - Microsoft"
    return `${item.code}_${item.name}_${item.non_specialist}`;
  }

  onReload = () => {
    this.props.history.push("/pelayanan");
  };
  chageIcdCase = (idx) => (event) => {
    const target = event.target;
    const icd = [...this.state.icd];
    const value = target.type === "checkbox" ? target.checked : target.value;
    if (value) {
      icd[idx].case = "new";
    } else {
      icd[idx].case = "old";
    }
    this.setState({ icd });
  };

  // examination
  handleChangeText = (event) => {
    const value = event.target.value;
    const object = event.target.name;
    let data;
    this.setState(
      (prevState) => ({
        data: {
          // object that we want to update
          ...prevState.data, // keep all other key-value pairs
          [object]: value, // update the value of specific key
        },
      }),
      () => {
        data = { data: [this.state.data], param: "examinations" };
        this.props.parentCallback(data);
      }
    );
  };

  //icpc
  retrieveDataAsynchronouslyIcpc = async (e) => {
    // console.log(e);

    const res = await API.get("management/icpc2/read?keyword=" + e);
    if (res.code === 200) {
      this.setState({
        list_icpc: res.data.data ?? [],
      });
    } else {
      console.error("Cannot load data from remote source");
    }
  };

  onChangeIcpc = (evt, icpc) => {
    const newIcd = {
      ...this.state[icpc],
      visit_id: this.props.patient.id,
      icd_name: evt.target.value,
    };
    this.setState({ [icpc]: newIcd }, () => console.log(icpc, newIcd));

    /**
     * Handle the remote request with the current text !
     */
    const par = evt.target.value;
    if (this.timeout) clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      if (par.length > 2) {
        this.retrieveDataAsynchronouslyIcpc(par);
      }
    }, 500);
  };

  /**
   * Callback triggered when the autocomplete input changes.
   *
   * @param {Object} val Value returned by the getItemValue function.
   * @return {Nothing} No value is returned
   */
  onSelectIcpc(val) {
    console.log(val, 'opt')
    this.setState({
      value: val,
    });
    const x = val.split("$", 2);
    console.log("Option from 'database' selected : ", x);
  }

  /**
   * Define the markup of every rendered item of the autocomplete.
   *
   * @param {Object} item Single object from the data that can be shown inside the autocomplete
   * @param {Boolean} isHighlighted declares wheter the item has been highlighted or not.
   * @return {Markup} Component
   */
  renderItemIcpc(item, isHighlighted) {
    return (
      <div
        key={item.id}
        style={{ background: isHighlighted ? "lightgray" : "white" }}
      >
        {item.code} _ {item.name}]
      </div>
    );
  }

  getItemValueIcpc(item) {
    // You can obviously only return the Label or the component you need to show
    // In this case we are going to show the value and the label that shows in the input
    // something like "1 - Microsoft"
    let icdNew = [];
    item.icd.length > 0
      ? item.icd.map((a) => {
          icdNew.push(a.icd_data ? a.icd_data : []);
        })
      : [];
    return `${item.code}$${item.name}$${JSON.stringify(icdNew)}`;
  }

  handleInputNameChangeIcpc = (evt, icpc) => {
    const val = evt.split("$", 3);
    const newIcd = {
      ...this.state[icpc],
      visit_id: this.props.patient.id,
      explanation: "",
      category: icpc,
      icd_name: val[1],
      code: val[0],
      soap: "A",
    };
    console.log(newIcd, icpc, 'hey')
    this.setState({ [icpc]: newIcd, dataIcd: JSON.parse(val[2]) ?? [] });
  };
  //end

  render() {
    let DeletedIcd = [];
    this.state.icd.map((icd, idx) => {
      if (icd.log) {
        DeletedIcd[idx] = icd;
      }
    });
    const deletedIcdInformation = DeletedIcd.map((data, key) => {
      return (
        <a key={key} className="dropdown-item">
          {data.icd_code} - {data.icd_name}
        </a>
      );
    });

    return (
      <>
        <Formik
          enableReinitialize
          initialValues={{
            icd: this.state.icpc_individu[0].diagnoses[0].icd_code,
          }}
          validationSchema={SignupSchema}
          onSubmit={(values) => {
            this.handleSubmit();
            this.props.nextTab();
          }}
        >
          {({ values, errors, touched }) => (
            <Form>
              <div className="row">
                <div className="col-md-12">
                  <div className="form-group row">
                    <label
                      htmlFor="example-text-input"
                      className="col-md-12 col-form-label col-form-label-sm"
                    >
                      Diagnosa Naratif
                    </label>
                    <div className="col-md-11 ml-3">
                      <div className="row">
                        <textarea
                          className="form-control form-control-sm"
                          type="text"
                          placeholder="Diagnosa naratif"
                          name="diagnostic_narativ"
                          onChange={this.handleChangeText}
                          value={this.state.data?.diagnostic_narativ}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                {this.state.icpc_individu.map((d, i) => (
                  <div className="col-md-12" key={i}>
                    <div>
                      <h2>Individu</h2>
                    </div>
                    <div className="form-group row">
                      <div className="col-md-5 ">
                        <div className="row">
                          <div className="col-md-6">
                            <label
                              htmlFor="example-text-input"
                              className="col-form-label col-form-label-sm"
                            >
                              ICPC
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-7">
                        <Autocomplete
                          inputProps={{
                            className: "form-control form-control-sm",
                            placeholder: "ketikkan minimal 3 huruf ICPC",
                          }}
                          ref={(input) => {
                            this.individu = input;
                          }}
                          getItemValue={this.getItemValueIcpc}
                          items={this.state.list_icpc}
                          renderItem={this.renderItemIcpc}
                          value={d.icd_name}
                          onChange={(e) =>
                            this.onChangeIcpc(e, "icpc_individu", i)
                          }
                          onSelect={(e) =>
                            this.handleInputNameChangeIcpc(
                              e,
                              "icpc_individu",
                              i
                            )
                          }
                          menuStyle={{
                            borderRadius: "3px",
                            boxShadow: "0 2px 12px rgba(0, 0, 0, 0.1)",
                            background: "rgba(255, 255, 255, 0.9)",
                            padding: "2px 0",
                            fontSize: "90%",
                            // position: "absolute",
                            overflow: "auto",
                            zIndex: "100",
                            maxHeight: "10%", // TODO: don't cheat, let it flow to the bottom
                          }}
                          wrapperStyle={{
                            maxWidth: "95%",
                            flex: "0 0 90%",
                            overflow: "auto",
                          }}
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <div className="col-md-5 ">
                        <div className="row">
                          <div className="col-md-6">
                            <label
                              htmlFor="example-text-input"
                              className="col-form-label col-form-label-sm"
                            >
                              ICD 10
                            </label>
                          </div>
                          {/* {DeletedIcd.length > 0 ? (
                            <div>
                              <div className="col-auto">
                                <button
                                  type="button"
                                  className="btn btn-sm btn-danger mr-0"
                                  data-toggle="dropdown"
                                  aria-haspopup="true"
                                  aria-expanded="false"
                                >
                                  dihapus
                                </button>
                                <div className="dropdown-menu dropdown-menu-left">
                                  {deletedIcdInformation}
                                </div>
                              </div>
                            </div>
                          ) : (
                            <div></div>
                          )} */}
                        </div>
                      </div>
                      <div className="col-md-7">
                        {d.diagnoses.map((icd, idx) => {
                          if (icd.log === false || icd.log === 0)
                            return (
                              <div key={idx} className="form-group row">
                                <Autocomplete
                                  inputProps={{
                                    className: "form-control form-control-sm",
                                    placeholder:
                                      "pilih dari icd yang disediakan",
                                  }}
                                  ref={(input) => {
                                    this.icd = input;
                                  }}
                                  getItemValue={this.getItemValue}
                                  items={this.state.dataIcd}
                                  renderItem={this.renderItem}
                                  value={
                                    icd.icd_name
                                      ? icd.icd_code + "" + icd.icd_name
                                      : ""
                                  }
                                  onSelect={this.handleInputNameChangeIcd(
                                    i,
                                    "icpc_individu"
                                  )}
                                  menuStyle={{
                                    borderRadius: "3px",
                                    boxShadow: "0 2px 12px rgba(0, 0, 0, 0.1)",
                                    background: "rgba(255, 255, 255, 0.9)",
                                    padding: "2px 0",
                                    fontSize: "90%",
                                    // position: "absolute",
                                    overflow: "auto",
                                    zIndex: "100",
                                    maxHeight: "50%", // TODO: don't cheat, let it flow to the bottom
                                  }}
                                  wrapperStyle={{
                                    maxWidth: "81.66667%",
                                    flex: "0 0 81.66667%",
                                    overflow: "auto",
                                  }}
                                />
                                <label className="custom-toggle custom-toggle-success">
                                  <input
                                    type="checkbox"
                                    checked={
                                      icd.case === "new" ? "checked" : ""
                                    }
                                    onChange={this.chageIcdCase(idx, i)}
                                  />
                                  <span
                                    className="custom-toggle-slider rounded-circle"
                                    data-label-off="lama"
                                    data-label-on="baru"
                                  />
                                </label>
                                {this.state.icpc_individu.length > 1 ? (
                                  <button
                                    type="button"
                                    className="btn btn-sm btn-danger"
                                    style={{ maxWidth: "10%" }}
                                    name="icpc_individu"
                                    onClick={this.handleRemoveInputIcd(i)}
                                  >
                                    -
                                  </button>
                                ) : (
                                  ""
                                )}
                              </div>
                            );
                        })}

                        {errors.icd && touched.icd ? (
                          <div style={{ color: "red" }}>{errors.icd}</div>
                        ) : null}
                      </div>
                    </div>
                  </div>
                ))}
                <div className="col-md-12">
                  <button
                    type="button"
                    name="icpc_individu"
                    style={{ marginLeft: "2%" }}
                    onClick={this.handleAddInput(
                      this.state.icpc_individu.concat([
                        {
                          visit_id: "",
                          explanation: "",
                          log: 0,
                          category: "individu",
                          icd_name: "",
                          soap: "A",
                          code: "",
                          icd10: "",
                          diagnoses: [
                            {
                              visit_id: "",
                              visit_inpatient_detail_id: "",
                              icd_code: "",
                              icd_name: "",
                              explanation: "",
                              date: "",
                              case: "new",
                              elemen_teeth: "",
                              log: false,
                              examination_type_id: "",
                            },
                          ],
                        },
                      ])
                    )}
                    className="btn btn-sm btn-primary center"
                  >
                    Add
                  </button>
                </div>
                {this.state.icpc_keluarga.map((d, i) => (
                  <div className="col-md-12" key={i}>
                    <div>
                      <h2>Keluarga</h2>
                    </div>
                    <div className="form-group row">
                      <div className="col-md-5 ">
                        <div className="row">
                          <div className="col-md-6">
                            <label
                              htmlFor="example-text-input"
                              className="col-form-label col-form-label-sm"
                            >
                              ICPC
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-7">
                        <Autocomplete
                          inputProps={{
                            className: "form-control form-control-sm",
                            placeholder: "ketikkan minimal 3 huruf ICPC",
                          }}
                          ref={(input) => {
                            this.individu = input;
                          }}
                          getItemValue={this.getItemValueIcpc}
                          items={this.state.list_icpc}
                          renderItem={this.renderItemIcpc}
                          value={d.icd_name}
                          onChange={(e) =>
                            this.onChangeIcpc(e, "icpc_keluarga", i)
                          }
                          onSelect={(e) =>
                            this.handleInputNameChangeIcpc(
                              e,
                              "icpc_keluarga",
                              i
                            )
                          }
                          menuStyle={{
                            borderRadius: "3px",
                            boxShadow: "0 2px 12px rgba(0, 0, 0, 0.1)",
                            background: "rgba(255, 255, 255, 0.9)",
                            padding: "2px 0",
                            fontSize: "90%",
                            // position: "absolute",
                            overflow: "auto",
                            zIndex: "100",
                            maxHeight: "10%", // TODO: don't cheat, let it flow to the bottom
                          }}
                          wrapperStyle={{
                            maxWidth: "95%",
                            flex: "0 0 90%",
                            overflow: "auto",
                          }}
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <div className="col-md-5 ">
                        <div className="row">
                          <div className="col-md-6">
                            <label
                              htmlFor="example-text-input"
                              className="col-form-label col-form-label-sm"
                            >
                              ICD 10
                            </label>
                          </div>
                          {/* {DeletedIcd.length > 0 ? (
                            <div>
                              <div className="col-auto">
                                <button
                                  type="button"
                                  className="btn btn-sm btn-danger mr-0"
                                  data-toggle="dropdown"
                                  aria-haspopup="true"
                                  aria-expanded="false"
                                >
                                  dihapus
                                </button>
                                <div className="dropdown-menu dropdown-menu-left">
                                  {deletedIcdInformation}
                                </div>
                              </div>
                            </div>
                          ) : (
                            <div></div>
                          )} */}
                        </div>
                      </div>
                      <div className="col-md-7">
                        {d.diagnoses.map((icd, idx) => {
                          if (icd.log === false || icd.log === 0)
                            return (
                              <div key={idx} className="form-group row">
                                <Autocomplete
                                  inputProps={{
                                    className: "form-control form-control-sm",
                                    placeholder:
                                      "pilih dari icd yang disediakan",
                                  }}
                                  ref={(input) => {
                                    this.icd = input;
                                  }}
                                  getItemValue={this.getItemValue}
                                  items={this.state.dataIcd}
                                  renderItem={this.renderItem}
                                  value={
                                    icd.icd_name
                                      ? icd.icd_code + "" + icd.icd_name
                                      : ""
                                  }
                                  onSelect={this.handleInputNameChangeIcd(
                                    i,
                                    "icpc_keluarga"
                                  )}
                                  menuStyle={{
                                    borderRadius: "3px",
                                    boxShadow: "0 2px 12px rgba(0, 0, 0, 0.1)",
                                    background: "rgba(255, 255, 255, 0.9)",
                                    padding: "2px 0",
                                    fontSize: "90%",
                                    // position: "absolute",
                                    overflow: "auto",
                                    zIndex: "100",
                                    maxHeight: "50%", // TODO: don't cheat, let it flow to the bottom
                                  }}
                                  wrapperStyle={{
                                    maxWidth: "81.66667%",
                                    flex: "0 0 81.66667%",
                                    overflow: "auto",
                                  }}
                                />
                                <label className="custom-toggle custom-toggle-success">
                                  <input
                                    type="checkbox"
                                    checked={
                                      icd.case === "new" ? "checked" : ""
                                    }
                                    onChange={this.chageIcdCase(idx, i)}
                                  />
                                  <span
                                    className="custom-toggle-slider rounded-circle"
                                    data-label-off="lama"
                                    data-label-on="baru"
                                  />
                                </label>
                                <button
                                  type="button"
                                  className="btn btn-sm btn-danger"
                                  style={{ maxWidth: "10%" }}
                                  name="icpc_keluarga"
                                  onClick={this.handleRemoveInputIcd(i)}
                                >
                                  -
                                </button>
                              </div>
                            );
                        })}

                        {errors.icd && touched.icd ? (
                          <div style={{ color: "red" }}>{errors.icd}</div>
                        ) : null}
                      </div>
                    </div>
                  </div>
                ))}
                <div className="col-md-12">
                  <button
                    type="button"
                    name="icpc_keluarga"
                    style={{ marginLeft: "2%" }}
                    onClick={this.handleAddInput(
                      this.state.icpc_keluarga.concat([
                        {
                          visit_id: "",
                          explanation: "",
                          log: 0,
                          category: "icpc_keluarga",
                          icd_name: "",
                          soap: "A",
                          code: "",
                          icd10: "",
                          diagnoses: [
                            {
                              visit_id: "",
                              visit_inpatient_detail_id: "",
                              icd_code: "",
                              icd_name: "",
                              explanation: "",
                              date: "",
                              case: "new",
                              elemen_teeth: "",
                              log: false,
                              examination_type_id: "",
                            },
                          ],
                        },
                      ])
                    )}
                    className="btn btn-sm btn-primary center"
                  >
                    Add
                  </button>
                </div>
                {this.state.icpc_komunitas.map((d, i) => (
                  <div className="col-md-12" key={i}>
                    <div>
                      <h2>Komunitas</h2>
                    </div>
                    <div className="form-group row">
                      <div className="col-md-5 ">
                        <div className="row">
                          <div className="col-md-6">
                            <label
                              htmlFor="example-text-input"
                              className="col-form-label col-form-label-sm"
                            >
                              ICPC
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-7">
                        <Autocomplete
                          inputProps={{
                            className: "form-control form-control-sm",
                            placeholder: "ketikkan minimal 3 huruf ICPC",
                          }}
                          ref={(input) => {
                            this.individu = input;
                          }}
                          getItemValue={this.getItemValueIcpc}
                          items={this.state.list_icpc}
                          renderItem={this.renderItemIcpc}
                          value={d.icd_name}
                          onChange={(e) =>
                            this.onChangeIcpc(e, "icpc_komunitas", i)
                          }
                          onSelect={(e) =>
                            this.handleInputNameChangeIcpc(
                              e,
                              "icpc_komunitas",
                              i
                            )
                          }
                          menuStyle={{
                            borderRadius: "3px",
                            boxShadow: "0 2px 12px rgba(0, 0, 0, 0.1)",
                            background: "rgba(255, 255, 255, 0.9)",
                            padding: "2px 0",
                            fontSize: "90%",
                            // position: "absolute",
                            overflow: "auto",
                            zIndex: "100",
                            maxHeight: "10%", // TODO: don't cheat, let it flow to the bottom
                          }}
                          wrapperStyle={{
                            maxWidth: "95%",
                            flex: "0 0 90%",
                            overflow: "auto",
                          }}
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <div className="col-md-5 ">
                        <div className="row">
                          <div className="col-md-6">
                            <label
                              htmlFor="example-text-input"
                              className="col-form-label col-form-label-sm"
                            >
                              ICD 10
                            </label>
                          </div>
                          {/* {DeletedIcd.length > 0 ? (
                            <div>
                              <div className="col-auto">
                                <button
                                  type="button"
                                  className="btn btn-sm btn-danger mr-0"
                                  data-toggle="dropdown"
                                  aria-haspopup="true"
                                  aria-expanded="false"
                                >
                                  dihapus
                                </button>
                                <div className="dropdown-menu dropdown-menu-left">
                                  {deletedIcdInformation}
                                </div>
                              </div>
                            </div>
                          ) : (
                            <div></div>
                          )} */}
                        </div>
                      </div>
                      <div className="col-md-7">
                        {d.diagnoses.map((icd, idx) => {
                          if (icd.log === false || icd.log === 0)
                            return (
                              <div key={idx} className="form-group row">
                                <Autocomplete
                                  inputProps={{
                                    className: "form-control form-control-sm",
                                    placeholder:
                                      "pilih dari icd yang disediakan",
                                  }}
                                  ref={(input) => {
                                    this.icd = input;
                                  }}
                                  getItemValue={this.getItemValue}
                                  items={this.state.dataIcd}
                                  renderItem={this.renderItem}
                                  value={
                                    icd.icd_name
                                      ? icd.icd_code + "" + icd.icd_name
                                      : ""
                                  }
                                  onSelect={this.handleInputNameChangeIcd(
                                    i,
                                    "icpc_komunitas"
                                  )}
                                  menuStyle={{
                                    borderRadius: "3px",
                                    boxShadow: "0 2px 12px rgba(0, 0, 0, 0.1)",
                                    background: "rgba(255, 255, 255, 0.9)",
                                    padding: "2px 0",
                                    fontSize: "90%",
                                    // position: "absolute",
                                    overflow: "auto",
                                    zIndex: "100",
                                    maxHeight: "50%", // TODO: don't cheat, let it flow to the bottom
                                  }}
                                  wrapperStyle={{
                                    maxWidth: "81.66667%",
                                    flex: "0 0 81.66667%",
                                    overflow: "auto",
                                  }}
                                />
                                <label className="custom-toggle custom-toggle-success">
                                  <input
                                    type="checkbox"
                                    checked={
                                      icd.case === "new" ? "checked" : ""
                                    }
                                    onChange={this.chageIcdCase(idx, i)}
                                  />
                                  <span
                                    className="custom-toggle-slider rounded-circle"
                                    data-label-off="lama"
                                    data-label-on="baru"
                                  />
                                </label>
                                <button
                                  type="button"
                                  className="btn btn-sm btn-danger"
                                  style={{ maxWidth: "10%" }}
                                  name="icpc_komunitas"
                                  onClick={this.handleRemoveInputIcd(i)}
                                >
                                  -
                                </button>
                              </div>
                            );
                        })}

                        {errors.icd && touched.icd ? (
                          <div style={{ color: "red" }}>{errors.icd}</div>
                        ) : null}
                      </div>
                    </div>
                  </div>
                ))}
                <div className="col-md-12">
                  <button
                    type="button"
                    name="icpc_komunitas"
                    style={{ marginLeft: "2%" }}
                    onClick={this.handleAddInput(
                      this.state.icpc_komunitas.concat([
                        {
                          visit_id: "",
                          explanation: "",
                          log: 0,
                          category: "icpc_komunitas",
                          icd_name: "",
                          soap: "A",
                          code: "",
                          icd10: "",
                          diagnoses: [
                            {
                              visit_id: "",
                              visit_inpatient_detail_id: "",
                              icd_code: "",
                              icd_name: "",
                              explanation: "",
                              date: "",
                              case: "new",
                              elemen_teeth: "",
                              log: false,
                              examination_type_id: "",
                            },
                          ],
                        },
                      ])
                    )}
                    className="btn btn-sm btn-primary center"
                  >
                    Add
                  </button>
                </div>
              </div>

              <button className="btn btn-primary">Simpan</button>
              <button className="btn btn-danger" onClick={this.onReload}>
                Tutup
              </button>
            </Form>
          )}
        </Formik>
      </>
    );
  }
}

export default Assesment;
